import template from './bot-manager-filter.html';
import BotManagerFilterController from './bot-manager-filter.controller';
import './bot-manager-filter.styl';

let botManagerFilterComponent = {
  restrict: 'E',
  bindings: {
    applyFilters: '&'
  },
  template,
  controller: BotManagerFilterController,
  controllerAs: 'vm'
};

export default botManagerFilterComponent;



/** WEBPACK FOOTER **
 ** E:/JUGGLE_STREET/Juggle-Street-Deployment-All/JSBIGFOOTFRONTEND-BACKEND/admin-frontend/client/app/common/Components/bot-manager-filter/bot-manager-filter.component.js
 **/